import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=51cf11b4&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default,ContentsBlocks: require('/home/vsts/work/1/a/NuxtApp/components/contents/Blocks.vue').default,BlogLayout: require('/home/vsts/work/1/a/NuxtApp/components/blog/Layout.vue').default})
